import { defineComponent } from "vue";
import { VueAutoHeight } from "@/core/vue-auto-height.component";
import CookieBannerCategory from "@/components/cookie-banner-category";
import Cookies from "cookies-ts";
import type { ConsentCookieType } from "@/services/cookies/ConsentCookieType";
import CookieService from "@/services/cookies/CookieService";

export default defineComponent({
  template: `
      <div class="cookie-banner-backdrop" v-if="this.isVisible">
      <div class="cookie-banner" v-if="this.isVisible">
        <div class="cookie-banner__main-part-container">
          <div class="container">
            <div class="cookie-banner__header row">
              <div class="cookie-banner-content col-12">
                  <h2 class="cookie-banner-content__header">
                    Informace o cookies
                  </h2>
                  <p class="cookie-banner-content__header-desc">
                    Díky cookies vám zprostředkujeme ojedinělý zážitek při prohlížení našeho webu.
                  </p>
                  <p class="cookie-banner-content__header-desc">
                    Cookies soubory zajišťují správné fungování základních funkcí našeho webu a přispívají k tomu, abyste si pobyt v online prostoru užili. Níže si můžete vybrat, jaké cookies chcete nebo nechcete povolit. Svou volbu můžete kdykoli změnit.
                  </p>
                  <!--<p class="cookie-banner-content__header-desc">
                    Analytické cookies používáme ke statistice návštěvnosti, personalizační nám pomáhají s přizpůsobením
                    webu pro vaši rychlejší orientaci a díky marketingovým cookies se vám zobrazí jen takové reklamy,
                    které vás opravdu zaujmou.
                  </p>-->
                  <p class="cookie-banner-content__header-desc">
                    Máte-li jakékoli dotazy ohledně našich zásad týkajících se cookies a vašeho výběru, 
                    <a href="/kontakty">kontaktujte nás</a>.
                  </p>
              </div>
            </div>
            <div class="cookie-banner__categories row" v-if="this.areSettingsVisible">
              <div class="col-12">
                <CookieBannerCategory v-model="this.consentCategories.necessary.value" :disabled="true">
                  <template #title>
                    Funkční cookies
                  </template>
                  <template #detail>
                    <p>
                      Funkční cookies jsou nezbytné pro základní funkčnost webových stránek a správné zobrazování
                      obsahu na počítači nebo v mobilním telefonu. Ve výchozím nastavení jsou povoleny automaticky
                      a nelze je zakázat.
                    </p>
                  </template>
                </CookieBannerCategory>
                <CookieBannerCategory v-model="this.consentCategories.analytics.value">
                  <template #title>
                    <p class="cookie-banner__category-title">Analytické cookies</p>
                  </template>
                  <template #detail>
                    <p>
                      Tento druh cookies analyzuje návštěvnost na našich stránkách. Shromažďuje statistické, nikoliv
                      osobní údaje, pro zlepšování výkonnosti a rychlosti stránek. Všechny informace, které tyto cookies
                      shromažďují, jsou anonymní.
                    </p>
                    <table>
                      <thead>
                      <tr>
                        <th scope="col">Název</th>
                        <th scope="col">Doména</th>
                        <th scope="col">Popis</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td data-column="Název">Google Analytics</td>
                        <td data-column="Doména">google.com</td>
                        <td data-column="Popis">Google Analytics je služba pro měření statistik návštěvnosti a chování
                          návštěvníků na webu. Veškerá data získaná touto službou jsou anonymizována a nelze je přiřadit
                          ke konkrétní osobě.
                        </td>
                      </tr>
                      <tr>
                        <td data-column="Název">Google Tag Manager</td>
                        <td data-column="Doména">google.com</td>
                        <td data-column="Popis">Google Tag Manager využíváme pro správu scriptů na našem webu. Tato služba
                          neshromažďuje žádné osobní údaje.
                        </td>
                      </tr>
                      <tr>
                        <td data-column="Název">Hotjar</td>
                        <td data-column="Doména">hotjar.com</td>
                        <td data-column="Popis">Hotjar je nástroj, který měří chování návštěvníků našeho webu. Podobá se
                          aplikaci Google Analytics. Poskytuje totiž údaje o tom, jak se lidé na webu pohybují.
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </template>
                </CookieBannerCategory>
                <CookieBannerCategory v-model="this.consentCategories.targeting.value">
                  <template #title>
                    <p class="cookie-banner__category-title">Personalizační cookies</p>
                  </template>
                  <template #detail>
                    <p>
                      Personalizační cookies pomáhají s přizpůsobením našeho webu konkrétně pro vás. Například ponechají
                      preferovanou jazykovou variantu stránek i při vaší další návštěvě.
                    </p>
                  </template>
                </CookieBannerCategory>
                <CookieBannerCategory v-model="this.consentCategories.ads.value">
                  <template #title>
                    <p class="cookie-banner__category-title">Marketingové cookies</p>
                  </template>
                  <template #detail>
                    <p>
                      Váš souhlas s marketingovými cookies nám pomůže s lepším cílením reklam a s personalizací reklamních
                      sdělení. Využijeme je k vyhodnocování marketingu, takže se vám budou zobrazovat opravdu relevantní
                      reklamy.
                    </p>
                    <table>
                      <thead>
                      <tr>
                        <th scope="col">Název</th>
                        <th scope="col">Doména</th>
                        <th scope="col">Popis</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td data-column="Název">Google Ads</td>
                        <td data-column="Doména">google.com</td>
                        <td data-column="Popis">Google Ads je reklamní služba, která zobrazuje reklamy při vyhledávání ve
                          službě Google, při surfování internetem, v aplikacích nebo při sledování videí na Youtube.
                          Službu využíváme také pro měření úspěšnosti kampaní a počtu provedených on-line objednávek na
                          našem webu.
                        </td>
                      </tr>
                      <tr>
                        <td data-column="Název">Facebook Ads</td>
                        <td data-column="Doména">facebook.com</td>
                        <td data-column="Popis">Facebook používáme pro zobrazování relevantních reklam na základě
                          zobrazených stránek našeho webu. Službu také využíváme pro měření úspěšnosti kampaní, konverzí
                          nebo remarketingu a počtu provedených on-line objednávkách na našem webu. Na webu nám tento
                          nástroj umožňuje cílit a vyhodnocovat reklamní sdělení podle toho, jak se na našich stránkách
                          chováte.
                        </td>
                      </tr>
                      <tr>
                        <td data-column="Název">Seznam.cz / Sklik</td>
                        <td data-column="Doména">seznam.cz</td>
                        <td data-column="Popis">Sklik je reklamní služba, která zobrazuje reklamy při vyhledávání ve
                          službě Seznam, při surfování internetem nebo při sledování videí na Televizi Seznam. Nástroj
                          používáme pro zobrazování textových a grafických reklam ve vyhledávací i obsahové síti a zároveň
                          pro měření úspěšnosti kampaní a počtu provedených on-line objednávek na našem webu.
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </template>
                </CookieBannerCategory>
              </div>
            </div>
            <div class="row">
              <div class="cookie-banner__cta col-12" v-if="! this.areSettingsVisible">
                <button class="cookie-banner__cta-accept" @click="this.acceptAllAndClose">Přijmout vše</button>
                <button class="cookie-banner__cta-settings hollow" @click="this.toggleSettings">
                  Podrobné nastavení
                </button>
              </div>
              <div class="cookie-banner__cta col-12" v-if="this.areSettingsVisible">
                <button class="cookie-banner__cta-accept" @click="this.acceptAllAndClose">Přijmout vše</button>
                <button class="cookie-banner__cta-save hollow" @click="this.saveToCookieAndClose">
                  Uložit nastavení
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    `,
  components: {
    CookieBannerCategory,
    VueAutoHeight,
  },
  data() {
    return {
      isVisible: false,
      areSettingsVisible: false,
      consentCategories: {
        necessary: {
          value: true,
          disabled: true,
          expanded: false,
        },
        analytics: {
          value: true,
          disabled: false,
          expanded: false,
        },
        targeting: {
          value: false,
          disabled: false,
          expanded: false,
        },
        ads: {
          value: false,
          disabled: false,
          expanded: false,
        },
      },
      cookies: new Cookies(),
    };
  },
  mounted() {
    this.loadFromCookie();
  },
  methods: {
    loadFromCookie() {
      const cookieRaw = this.$store.direct.getters.cookieService.getCookieOne("consent");
      if (!cookieRaw) {
        this.isVisible = true;
        return;
      }
      const cookieParsed: ConsentCookieType = JSON.parse(cookieRaw);
      for (const category of cookieParsed.level ?? []) {
        if (category === "necessary") {
          this.consentCategories.necessary.value = true;
        }
        if (category === "analytics") {
          this.consentCategories.analytics.value = true;
        }
        if (category === "targeting") {
          this.consentCategories.targeting.value = true;
        }
        if (category === "ads") {
          this.consentCategories.ads.value = true;
        }
      }
      this.updateGtag();
    },
    acceptAllAndClose() {
      this.consentCategories.necessary.value = true;
      this.consentCategories.analytics.value = true;
      this.consentCategories.targeting.value = true;
      this.consentCategories.ads.value = true;
      this.saveToCookieAndClose();
    },
    toggleSettings() {
      this.areSettingsVisible = !this.areSettingsVisible;
    },
    saveToCookieAndClose() {
      const cookieService = new CookieService();
      const levelArr = [];
      if (this.consentCategories.necessary.value) {
        levelArr.push("necessary");
      }
      if (this.consentCategories.analytics.value) {
        levelArr.push("analytics");
      }
      if (this.consentCategories.targeting.value) {
        levelArr.push("targeting");
      }
      if (this.consentCategories.ads.value) {
        levelArr.push("ads");
      }
      cookieService.setCookie(
        "consent",
        JSON.stringify({
          data: null,
          level: levelArr,
          revision: 0,
          rfc_cookie: false,
        }),
        levelArr.length !== 4 ? 1 : 365 // if not complete consent, store the cookie for 1 day, otherwise an year
      );
      this.isVisible = false;
      this.updateGtag();
    },
    updateGtag() {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        const consentData: { [key: string]: string } = {};

        if (this.consentCategories.analytics.value) {
          consentData.analytics_storage = "granted";
        }

        if (this.consentCategories.ads.value) {
          consentData.ad_user_data = "granted";
          consentData.ad_personalization = "granted";
          consentData.ad_storage = "granted";
        }

        if (Object.keys(consentData).length > 0) {
          // Tell Google Services that the Consent was updated
          window.gtag("consent", "update", consentData);
          // Send GTM event, so we can init the tracking scripts waiting for this event
          window.dataLayer.push({
            event: "consent_update",
            category: "consent",
            label: "updated",
          });
        }
      }
    },
  },
});
